<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <div class="d-flex align-items-center">
                                <div class="edit">
                                    <button title="back page" (click)="backToGoalProfile()">
                                    <span><i class="ri-arrow-left-line"></i></span>
                                    </button>
                                </div>
                                <h3 class="px-3">Skill Matrix</h3>
                            </div>
                        </div>
                        <div class="col-sm-4 d-flex justify-content-end">
                            <div>
                                <button type="button" title="Create" (click)="createOpenModal()" data-bs-toggle="modal" data-bs-target="#skills" class="btn btn-icon">
                                    <i class="ri-add-line"></i>
                                </button>
                              </div>
                        </div>
                    </div>
                   
                    <ag-grid-angular
                        style="height: 620px;" 
                        class="ag-theme-material"
                        (gridReady)="onGridReady($event)" 
                        [rowData]="rowData" 
                        [columnDefs]="columnDefs"
                        pagination="true" 
                        [defaultColDef]="defaultColDef"
                        [suppressRowClickSelection]="true"
                        (cellValueChanged)="onCellValueChanged($event)"
                        [rowSelection]="rowSelection"
                        paginationPageSize=10>
                   </ag-grid-angular>
                  
                </div>
            </section>
        </section>
    </article>
</main>

<div class="modal fade bd-example-modal-lg" id="skills" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="skillForm">
                <div class="modal-header">
                    <h5 class="modal-title">Create Skill/SubSkill</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="col-sm-8">
                        <div class="input">
                            <div class="input-item">
                                <input formControlName="skill" required>
                                <label class="floating-label-special">Skill*</label>
                                <i class="ri-menu-unfold-line"></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-8">
                        <div class="input">
                            <div class="input-item">
                                <input formControlName="subSkill" required>
                                <label class="floating-label-special">Sub-Skill*</label>
                                <i class="ri-menu-unfold-line"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModal" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createSkill()" [disabled]="!skillForm.valid">Create</button>
                </div>
            </form>
        </div>
    </div>
  </div>
